import React, {useState, useEffect} from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import TecnologiaService from '@app/services/tecnologia.service';

const Styles = styled.div``;

const SelectTecnologias = ({id, value, onChange, isInvalid, isClearable}) => {
    const [items, setItems] = useState([]);
    const [options, setOptions] = useState([]);
    const [selectedValue, setSelectedValue] = useState();

    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };

    useEffect(() => {
        TecnologiaService.getAll().then((response) => {
            setItems(response);
            const newOptions = response.map((item) => {
                return {
                    value: item.id_tec,
                    label: item.nombre_tec
                };
            });
            setOptions(newOptions);
            if (typeof value === 'string' || typeof value === 'number') {
                setSelectedValue(
                    newOptions.find((opt) => opt.value === Number(value))
                );
            } else if(Array.isArray(value)){
                setSelectedValue(value.map(va=>({label:va.nombre_tec,value:va.id_tec})));
            }
        });
    }, []);
    return (
        <Styles>
            <Select
                inputId={id}
                className={`react-select-container ${
                    isInvalid ? 'is-invalid' : ''
                }`}
                styles={{menuPortal: (base) => ({...base, zIndex: 9999})}}
                menuPortalTarget={document.body}
                classNamePrefix="react-select"
                placeholder="Seleccione..."
                options={options}
                value={selectedValue}
                onChange={onSelectValue}
                isClearable={isClearable}
            />
        </Styles>
    );
};

SelectTecnologias.defaultProps = {
    isClearable: false
};

export default SelectTecnologias;
